import { x as c, c as E } from "../lit-element-8JrrHldg.js";
import { n as $ } from "../property-4FoNj0Pi.js";
import { r as T } from "../state-D4BCZ2JK.js";
import { e as k } from "../class-map-Di-Oe7s4.js";
import { o as a } from "../if-defined-Cd-e8xtV.js";
import { I as x } from "../IdController-Cpj_A6H5.js";
import { P as L } from "../pwc-element-CZs0VuUW.js";
import "./pwc-header-menu-item.js";
import "./pwc-icon.js";
import { p as P } from "../pwcProperty-CTLG9yrF.js";
var A = Object.defineProperty, W = Object.getOwnPropertyDescriptor, l = (e, t, o, d) => {
  for (var r = d > 1 ? void 0 : d ? W(t, o) : t, s = e.length - 1, u; s >= 0; s--)
    (u = e[s]) && (r = (d ? u(t, o, r) : u(r)) || r);
  return d && r && A(t, o, r), r;
}, B = (e, t, o) => {
  if (!t.has(e))
    throw TypeError("Cannot " + o);
}, h = (e, t, o) => (B(e, t, "read from private field"), o ? o.call(e) : t.get(e)), w = (e, t, o) => {
  if (t.has(e))
    throw TypeError("Cannot add the same private member more than once");
  t instanceof WeakSet ? t.add(e) : t.set(e, o);
}, f, m, _;
const y = "pwc-header-menu";
let i = class extends L {
  constructor() {
    super(...arguments), this.slotControlled = ["icon", "dropdownIcon", "menuContent", "menuItems"], this._didClickOutside = (e) => h(this, f).call(this, e), this.idController = new x(this, {
      base: "PwcHeaderMenu",
      children: [
        "icon",
        "dropdownList",
        "dropdownContainer",
        "dropdownTitle",
        "menuItem"
      ]
    }), this.isOpen = !1, w(this, f, (e) => {
      const t = e.target;
      this.contains(t) || (this.isOpen = !1);
    }), w(this, m, (e) => {
      e.key === "Escape" && (this.isOpen = !1);
    }), w(this, _, () => {
      setTimeout(() => {
        Array.from(this.querySelectorAll("pwc-header-menu-item")).find((t) => t.focused) || (this.isOpen = !1);
      }, 0);
    });
  }
  connectedCallback() {
    super.connectedCallback(), document.addEventListener("click", this._didClickOutside);
  }
  disconnectedCallback() {
    document.removeEventListener("click", this._didClickOutside), super.disconnectedCallback();
  }
  render() {
    const {
      slotted: e,
      icon: t,
      iconPath: o,
      label: d,
      menuItems: r,
      isOpen: s,
      showIndicator: u,
      idController: {
        child: {
          icon: v,
          dropdownList: M,
          dropdownContainer: C,
          dropdownTitle: O,
          menuItem: b
        }
      }
    } = this, I = (n) => {
      const p = c`<p-slot .host=${this} name=${n}></p-slot>`;
      return e.icon ? p : t != null && t.length ? c`${p}<pwc-icon
            icon=${t}
            size="24"
          ></pwc-icon>` : o != null && o.length ? c`${p}<img src=${o} />` : p;
    }, g = () => e.menuItems ? null : r.map(
      (n, p) => c`
          <pwc-header-menu-item
            id=${`${b}__${p + 1}`}
            label=${n.label}
            icon=${a(n.icon)}
            icon-path=${a(n.iconPath)}
            target=${a(n.target)}
            ?is-form=${"isForm" in n && n.isForm}
            href=${a("href" in n ? n.href : void 0)}
            action=${a("action" in n ? n.action : void 0)}
            method=${a("method" in n ? n.method : void 0)}
            csrf-token=${a(
        "csrfToken" in n ? n.csrfToken : void 0
      )}
            .handler=${"handler" in n ? n.handler : void 0}
            @click=${() => this.isOpen = !1}
          ></pwc-header-menu-item>
        `
    ), H = () => e.menuContent ? null : c`
        <ul id=${M} aria-labelledby=${v} role="menu">
          <p-slot .host=${this} name="menuItems"></p-slot>
          ${g()}
        </ul>
      `;
    return c`
      <div class="PwcHeaderMenu">
        <button
          id=${v}
          class=${k({
      PwcHeaderMenu__icon: !0,
      "PwcHeaderMenu__icon--open": s
    })}
          aria-label=${a(d)}
          aria-haspopup="true"
          aria-controls=${C}
          aria-expanded=${s}
          @click=${() => this.isOpen = !s}
          @keydown=${h(this, m)}
        >
          ${u ? c`<span class="PwcHeaderMenu__icon__indicator" />` : null}
          ${I("icon")}
        </button>
        <div
          id=${C}
          class=${k({
      PwcHeaderMenu__dropdown: !0,
      "PwcHeaderMenu__dropdown--open": s
    })}
          @keydown=${h(this, m)}
        >
          <div
            id=${O}
            class="PwcHeaderMenu__label"
            aria-hidden="true"
          >
            <span class="PwcHeaderMenu__label__icon">
              ${I("dropdownIcon")}
            </span>
            <span class="PwcHeaderMenu__label__text"> ${d} </span>
          </div>
          <div
            class="PwcHeaderMenu__content"
            @menu-item-clicked=${() => this.isOpen = !1}
            @p-menu-item-clicked=${() => this.isOpen = !1}
            @p-blur=${h(this, _)}
          >
            <p-slot .host=${this} name="menuContent"></p-slot>
            ${H()}
          </div>
        </div>
      </div>
    `;
  }
};
f = /* @__PURE__ */ new WeakMap();
m = /* @__PURE__ */ new WeakMap();
_ = /* @__PURE__ */ new WeakMap();
i.tagName = y;
l([
  $()
], i.prototype, "label", 2);
l([
  $()
], i.prototype, "icon", 2);
l([
  $({ attribute: "icon-path" })
], i.prototype, "iconPath", 2);
l([
  P({ type: Boolean, attribute: "show-indicator", default: !1 })
], i.prototype, "showIndicator", 2);
l([
  P({ type: Array, attribute: "menu-items", default: [] })
], i.prototype, "menuItems", 2);
l([
  T()
], i.prototype, "isOpen", 2);
i = l([
  E(y)
], i);
export {
  i as PwcHeaderMenu
};
